module.exports = __webpack_public_path__ + "img/logo-end-user.2401ad2.png";